module.exports = __webpack_public_path__ + "static/img/step_one.55667b1a.png";